export default {"src":"/_next/static/media/vertical_view.1892caac.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};